const THEME_KEY = 'X-LAS-Theme';

export const getTheme = () => {
    return JSON.parse(localStorage.getItem(THEME_KEY));
};

export const setTheme = (light) => {
    localStorage.setItem(THEME_KEY, JSON.stringify(light));
};
